import { converterDataEua } from "_utils/Data";
import { TipoSolicitacaoPlaca } from "../constants/tipoSolicitacaoPlaca";
import { IFiltrosLote } from "../interfaces/IFiltrosLote";
import { IOrdenacao } from "../interfaces/IOrdenacao";

interface IParametrosBuscaLotes {
  tipo: TipoSolicitacaoPlaca;
  filtros: IFiltrosLote;
  ordenacao: IOrdenacao;
  pagina?: number;
  limite?: number;
}

export function montarParametrosLotes({
  tipo,
  filtros,
  ordenacao,
  pagina,
  limite,
}: IParametrosBuscaLotes): URLSearchParams {
  const parametros = new URLSearchParams({ tipo });
  const pdi = filtros.pdi.trim();
  const placa = filtros.placa.trim();
  const [inicio, fim] = filtros.periodoCriacao ?? [];

  if (pagina !== undefined) parametros.set("pagina", String(pagina));
  if (limite !== undefined) parametros.set("limite", String(limite));
  parametros.set("ordenarPor", ordenacao.campo);
  parametros.set("ordem", ordenacao.direcao);

  if (pdi) parametros.set("pdi", pdi);
  filtros.idLote.forEach((idLote) => parametros.append("idLote", idLote));
  if (filtros.prensa !== null) parametros.set("prensa", String(filtros.prensa));
  if (filtros.statusAutorizacao !== null)
    parametros.set("statusAutorizacao", String(filtros.statusAutorizacao));
  if (filtros.statusProducao !== null)
    parametros.set("statusProducao", String(filtros.statusProducao));
  if (filtros.idUsuario !== null)
    parametros.set("idUsuario", String(filtros.idUsuario));
  if (placa) parametros.set("placa", placa);
  if (inicio) parametros.set("dataInicio", converterDataEua(inicio) as string);
  if (fim) parametros.set("dataFim", converterDataEua(fim) as string);

  return parametros;
}
